import { useMemo } from 'react';

import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { REGISTRATION_TEMPLATES } from '@interlayer/js/app/store/reducers/Registration/constants';

type TUseDistributorForRegType<O, R, S> = {
    online: O;
    retail: R;
    slot: S;
}

export const useDistributorByTemplate = <O, R, S>({ online, retail, slot }: TUseDistributorForRegType<O, R, S>) => {
    const { config: { registrationForcedType } } = useRegistrationSelector();

    return useMemo(() => {
        switch (registrationForcedType) {
            case REGISTRATION_TEMPLATES.retailUpgrade:
            case REGISTRATION_TEMPLATES.retailReg: {
                return retail;
            }

            case REGISTRATION_TEMPLATES.slotReg:
            case REGISTRATION_TEMPLATES.slotUpgrade: {
                return slot;
            }

            case REGISTRATION_TEMPLATES.default:
            case REGISTRATION_TEMPLATES.upgrade:
            default: {
                return online;
            }
        }
    }, [online, slot, registrationForcedType, retail]);
};
